module.exports = __webpack_public_path__ + "img/vaccine_appiontment_bg.dec813f6.png";